import request from '@/utils/request'

// 生产环境api路径

// 获取学校信息
export function getOrg (data) {
  return request({
    data: data,
    url: '/old/queryOrganization',
    method: 'post'
  })
}
// 热门机构
export function getRandOrg () {
  return request({
    url: '/old/randinstitute',
    method: 'post'
  })
}

// 成果概览等数据
export function getRes (data) {
  return request({
    data: data,
    url: '/old/organizationAnalysis',
    method: 'post'
  })
}

// 学术趋势明细
export function getTrend (data) {
  return request({
    data: data,
    url: '/old/analyzeKeywordTrend',
    method: 'post'
  })
}

// 开发环境api路径

// // 获取学校信息
// export function getOrg (data) {
//   return request({
//     data: data,
//     url: '/api/queryOrganization',
//     method: 'post'
//   })
// }

// // 热门机构
// export function getRandOrg () {
//   return request({
//     url: '/api/randinstitute',
//     method: 'post'
//   })
// }

// // 成果概览等数据
// export function getRes (data) {
//   return request({
//     data: data,
//     url: '/api/organizationAnalysis',
//     method: 'post'
//   })
// }
// // 学术趋势明细
// export function getTrend (data) {
//   return request({
//     data: data,
//     url: '/api/analyzeKeywordTrend',
//     method: 'post'
//   })
// }



// WEBPACK FOOTER //
// ./src/api/organization.js